<template>
    <div v-if="item.message">
        <div class="msg-item">
            <!-- 名字 -->
            <span class="name notice">{{item.name}}：</span>
            <!-- msg -->
            <span class="text">{{item.message}}</span>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    item: {}
  },
  data () {
    return {}
  },
  methods: {
  },
  computed: {}
}
</script>
<style lang="scss" scoped>
    .msg-item {
        background: rgba(0, 0, 0, 0.25);
        border-radius: 0.84375rem;
        border-radius: 0.84375rem;
        display: inline-block;
        padding: 0.2953125rem 0.421875rem;
        max-width: 80vw;
        color: #fff;
        font-size:$fontSize;
        margin-bottom: 0.3375rem;
    }
    .lv {
        height: 0.6328125rem;
        width: 1.0546875rem;
        vertical-align: middle
    }
    .name {
        font-family: PingFangSC-Regular;
        font-size:$subFontSize;
        color: #9FE5FF;
        letter-spacing: 0;
        vertical-align: middle;
    }
    .text {
        line-height: 0.7rem;
        word-wrap:break-word
    }
</style>
